import { TimesheetViewSkeleton } from "@/modules/timesheet/logs/log/view/loader";
import { useFetch } from "@/hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import { deleteDraftTimesheetEntry, fetchDraftTimesheetEntry } from "@/modules/timesheet/draft/api";
import TimesheetLog from "@/modules/timesheet/logs/log/create";
import { eventBus } from "utils/eventBus";

export default function DraftTimesheetView() {
  const { draftId } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useFetch({
    queryKey: ["draft_timesheet", draftId],
    queryFn: () => fetchDraftTimesheetEntry({ draftId }),
  });

  const onSuccess = async () => {
    await deleteDraftTimesheetEntry({ id: draftId });
    eventBus.emit("refresh", `timesheet-${data?.date}`);
    eventBus.emit("refresh", `draft_timesheet-${data?.date}`);
    // Navigate back or to a specific page after success
    navigate(-1);
  };

  if (isLoading) {
    return <TimesheetViewSkeleton />;
  }

  if (isError) {
    return "error";
  }

  const initialValues = {
    date: data?.date,
    logged_hours: data?.logged_hours ? String(data.logged_hours) : "",
    description: data?.description || "",
    tag: data?.tag?.id || data?.tag,
    project: "",
    job: "",
    milestone: "",
  };

  const onDelete = async () => {
    await deleteDraftTimesheetEntry({ id: draftId });
    eventBus.emit("refresh", `draft_timesheet-${data?.date}`);
    navigate(-1);
  };

  return (
    <TimesheetLog
      initialValues={initialValues}
      onSuccess={onSuccess}
      onDelete={onDelete}
      created_from_draft={true}
    />
  );
}
